import React from "react";
import { Experience, Package } from "types";
import { NoTranslate } from "../Common/NoTranslate";
import { ProductImage } from "../Common/ProductImage";
import { CreatePurchaseAddOnField } from "./CreatePurchaseAddOnField";
import { CreatePurchasePackageArrivalPicker } from "./CreatePurchasePackageArrivalPicker";
import { CustomLineItemList } from "./CustomLineItemList";
import { getPackageAddOnsInExperience } from "@/models/Package";
import { CreatePurchaseItemState } from "@/stores/createPurchaseStore";

interface CreatePackageExperiencesProps {
    packageExperiences: Experience[];
    items: CreatePurchaseItemState[];
    pkg: Package;
}

export const CreateSharedPackageExperiences = ({ packageExperiences, items, pkg }: CreatePackageExperiencesProps) => {
    return (
        <>
            {packageExperiences.map((experience) => {
                const itemIndex = items.findIndex((item) => experience.id === item.product.id);

                const addOnCatalogItems = getPackageAddOnsInExperience(pkg, experience);
                const item = items[itemIndex];
                const { addonLineItems } = item;

                return (
                    <div
                        key={experience.id}
                        data-testid="create-purchase-package-fields-experience-item"
                        className="w-full space-y-4 border-b border-gray-light pb-8"
                    >
                        <div className="product-image mt-8 flex items-center">
                            <ProductImage product={experience} size="small" />
                            <NoTranslate className="font-bold">{experience.name}</NoTranslate>
                        </div>
                        <CreatePurchasePackageArrivalPicker value={item} experience={experience} />
                        {addOnCatalogItems.length > 0 ? (
                            <CreatePurchaseAddOnField
                                experience={experience}
                                lineItems={addonLineItems}
                                activeItemIndex={itemIndex}
                                catalogItems={addOnCatalogItems}
                            />
                        ) : null}

                        <CustomLineItemList itemIndex={itemIndex} />
                    </div>
                );
            })}
        </>
    );
};
